export default __webpack_public_path__ + "static/media/cambridge-small.1cef814a.png";